/** It checks if the user is authenticated, if they are,
 it renders the "component" prop. If not, it redirects
 the user to /login.
 **/
import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import { log } from '../utils/helpers'
import { useKeycloak } from '@react-keycloak/web'
import { NamedRoutes } from '../routes'
import { SearchLoader } from '../components/Loader/SearchLoader'

const PrivateRoute = ({ component: Component, ...rest }) => {
  const { keycloak, initialized } = useKeycloak()
  log('Access Token is set:', keycloak?.authenticated)
  return (
    <>
      {!initialized && <SearchLoader loading={true}/>}
      {!!initialized &&
      <Route {...rest} render={(props) => (
        keycloak?.authenticated ?
          <Component {...props} /> :
          <Redirect to={{
            pathname: NamedRoutes.home,
            state: { from: props.location }
          }}/>
      )}/>}
    </>
  )
}
export default PrivateRoute
